import React from 'react'

import { useCampaignParts } from '@/app/module/campaigns/component/hooks/use-campaign-parts'

import ActionPreview, { ActionPreviewProps } from './action-preview'

type Props = Omit<ActionPreviewProps, 'parts'>

// This component is used as a container to access current campaign parts and pass them to ActionPreview.
// We need this because ActionPreview can be used in a different context (e.g. in a modal) where the parts are not available.
const ActionPreviewContainer: React.FC<Props> = (props) => {
  const parts = useCampaignParts()

  return <ActionPreview {...props} parts={parts} />
}

export default ActionPreviewContainer
